/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Services_Svc_Full_BodyInputs */

const en_services_svc_full_body = /** @type {(inputs: Services_Svc_Full_BodyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`When the job is bigger than one workflow: models, data, integrations, an AI gateway with budgets and fallbacks, self-hosted infrastructure and monitoring. One engineer owns all of it, from design to the day after launch.`)
};

const lv_services_svc_full_body = /** @type {(inputs: Services_Svc_Full_BodyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kad uzdevums ir lielāks par vienu darba plūsmu: modeļi, dati, integrācijas, AI vārteja ar budžetiem un rezerves ceļiem, pašu uzturēta infrastruktūra un uzraudzība. Par visu atbild viens inženieris, no projektēšanas līdz dienai pēc palaišanas.`)
};

/**
* | output |
* | --- |
* | "When the job is bigger than one workflow: models, data, integrations, an AI gateway with budgets and fallbacks, self-hosted infrastructure and monitoring. On..." |
*
* @param {Services_Svc_Full_BodyInputs} inputs
* @param {{ locale?: "en" | "lv" }} options
* @returns {LocalizedString}
*/
export const services_svc_full_body = /** @type {((inputs?: Services_Svc_Full_BodyInputs, options?: { locale?: "en" | "lv" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Services_Svc_Full_BodyInputs, { locale?: "en" | "lv" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "lv") return lv_services_svc_full_body(inputs)
	return en_services_svc_full_body(inputs)
});